import React, { Component } from 'react'
import { connect } from 'react-redux'
import clients from 'redux/clients'
import BillPayment from './BillPayment'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import moment from 'moment'

class ByllPaymentContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isloading: true,
      isLoadingChangeAccountType: false,
      vendorId: 21188,
      maskLengthAccountType: 51,
      maskAccountType: [],
      accountType: [],
      barCode: '',
      documentNumber: props.cpf ? props.cpf.value : '',
      dueDate: '',
      billValue: '',
      pointsValue: '',
      isPriceEditable: false,
      name: '',
      errorPage: null,
      successPage: null,
      errorField: null,
      showTerms: false,
      acceptTerms: false,
      serviceId: ''
    }

    this.handlerChangeAccountType = this.handlerChangeAccountType.bind(this)
    this.handlerGetData = this.handlerGetData.bind(this)
    this.handlerCloseError = this.handlerCloseError.bind(this)
    this.handlerCloseSuccess = this.handlerCloseSuccess.bind(this)
    this.handlerFinalizePayment = this.handlerFinalizePayment.bind(this)
    this.handlerAccountTypes = this.handlerAccountTypes.bind(this)

    this.closeterms = this.closeterms.bind(this)
    this.acceptTermsEvent = this.acceptTermsEvent.bind(this)
    this.showTermsEvent = this.showTermsEvent.bind(this)

    this.handleBillValue = this.handleBillValue.bind(this)
    this.handleCoversionPointsValue = this.handleCoversionPointsValue.bind(this)
  }
  count = 0
  client
  componentDidMount () {
    if (this.count === 0) {
      this.count++
      const {
        cloudloyalty: { client }
      } = clients

      this.client = client
      this.handlerAccountTypes()
    }

    const { location } = this.props
    if (location && location.state && location.state.hasError) {
      const { barCode, dueDate, serviceId, error } = location.state

      this.ExceptionFinalizePayment(error)
      this.setState({ barCode, dueDate, serviceId, acceptTerms: true })

      this.calculatePoints({ barCode, serviceId })
    }
  }

  acceptTermsEvent (checked) {
    this.setState({
      showTerms: false,
      acceptTerms: checked
    })
  }

  showTermsEvent () {
    this.setState({
      showTerms: true
    })
  }

  closeterms () {
    this.setState({ showTerms: false })
  }

  handleBarCodeChange = ({ target: { value } }) => {
    const valueFormated = value.trim().match(/\d+/g)
    if (valueFormated) {
      const barCode = valueFormated.join([])
      this.setState({ barCode })
      return
    }
    this.setState({ barCode: value })
  }

  handleBarCodeBlur = () => {
    const { barCode, serviceId } = this.state
    this.calculatePoints({ serviceId, barCode })
  }

  handlerGetData (e) {
    this.setState({ dueDate: moment(e).format('DD/MM/YYYY') })
  }

  calculatePoints = ({ barCode, serviceId }) => {
    if (!barCode || !serviceId) return
    if (barCode.substr(barCode.length - 5) === '00000') {
      this.setState({
        billValue: 0,
        pointsValue: 0.0,
        isPriceEditable: true,
        name: '',
        isloading: false,
        isLoadingChangeAccountType: false
      })
      return
    }

    this.setState({ isLoadingChangeAccountType: true })

    this.client
      .get(
        `/v1/billPayments/vendor/${
          this.state.vendorId
        }/service/${serviceId}/validate/${barCode}`
      )
      .then(result => {
        this.setState({
          ...result.data,
          errorField: null,
          serviceId,
          barCode,
          isLoadingChangeAccountType: false
        })
      })
      .catch(ex => this.ExceptionChangeAccountType(ex))
  }

  handleBillValue (e) {
    const validValue = e.target.value === '' ? 0 : e.target.value
    if (!validValue) {
      this.setState({
        billValue: 0
      })
      return
    }

    const result = validValue.replace(/\./g, '').replace(',', '')
    const formated = Number(`${result.substr(0, result.length - 2)}.${result.substr(result.length - 2, result.length)}`)

    if (isNaN(formated)) {
      this.setState({
        billValue: 0
      })
    }
    this.setState({
      billValue: formated
    })
  }

  handleCoversionPointsValue () {
    this.client.get(`v1/billPayments/convertCashToPoints/vendor/${this.state.vendorId}/catalog/${process.env.REACT_APP_CATALOG_ID}/sellingPrice/${this.state.billValue}/`)
      .then(result =>
        this.setState({ pointsValue: result.data })
      )
      .catch(ex => this.ExceptionChangeAccountType(ex))
  }

  handlerChangeAccountType ({ serviceId }) {
    let defaultNotDigit = new RegExp(/[^ -//]/)
    let arrayRegularExpression = this.state.accountType.find(item => item.serviceId === serviceId).mask.split(',')
    let arrayMask = arrayRegularExpression.map(i => defaultNotDigit.test(i) ? new RegExp(i) : i)
    const { barCode } = this.state
    this.setState({
      serviceId,
      maskAccountType: arrayMask,
      maskLengthAccountType: this.state.accountType.find(item => item.serviceId === serviceId).maskLength
    })
    this.calculatePoints({ serviceId, barCode })
  }

  ExceptionChangeAccountType (ex) {
    const {
      response: { data }
    } = ex

    if (data.errors) {
      if (data.errors[0].code === 11) {
        this.setState({
          errorField: false,
          billValue: 0,
          pointsValue: 0.0,
          isPriceEditable: true,
          name: '',
          isloading: false,
          isLoadingChangeAccountType: false
        })
      }
    }
  }

  handlerFinalizePayment () {
    if (!this.state.acceptTerms) {
      return this.handlerShowErrorPage(
        'Regulamento',
        'Favor aceitar o Regulamento!'
      )
    }

    const payment = {
      serviceId: this.state.serviceId,
      barCode: this.state.barCode,
      dueDate: moment(this.state.dueDate, 'DD/MM/YYYY').format('MM/DD/YYYY'),
      documentNumber: this.props.cpf.value,
      billValue: this.state.billValue
    }

    this.setState({ loadingPayment: true })

    this.client
      .post('/v1/purchases/billPayment', payment)
      .then(response => {
        this.setState({
          loadingPayment: false,
          successPage: {
            title: 'Pagamento!',
            description: 'Seu pagamento foi realizado com sucesso!'
          },
          serviceId: '',
          barCode: '',
          dueDate: '',
          billValue: '',
          pointsValue: '',
          name: ''
        })

        const {
          data: { id }
        } = response

        this.props.redirectConfirmation(`/confirmation/${id}`)
      })
      .catch(ex => this.ExceptionFinalizePayment(ex.response.data))
  }

  ExceptionFinalizePayment (data) {
    this.setState({
      loadingPayment: false
    })

    const message = data
      ? data.errors[0].message.replace(
        'DueDate inválido',
        'Data de vencimento inválida'
      )
      : data

    this.handlerShowErrorPage(
      'Erro ao tentar efetuar o pagamento!',
      data ? message : 'problemas técnicos'
    )
  }

  handlerCloseError () {
    this.setState({ errorPage: null })
  }

  handlerCloseSuccess () {
    this.setState({ successPage: null })
  }

  handlerShowErrorPage (title, description) {
    this.setState({
      errorPage: {
        title: title,
        description: description,
        closeError: () => this.handlerCloseError()
      }
    })
  }

  handlerAccountTypes () {
    this.client
      .get(`/v1/billPayments/vendor/${this.state.vendorId}/service`)
      .then(result => {
        this.setState({ isloading: false, accountType: result.data })
      })
      .catch(() =>
        this.handlerShowErrorPage(
          '! tipos de contas',
          'erro ao tentar obter os tipos de contas'
        )
      )
  }

  render () {
    return (
      <BillPayment
        {...this.state}
        handlerChangeAccountType={this.handlerChangeAccountType}
        handlerFinalizePayment={this.handlerFinalizePayment}
        handleBarCodeChange={this.handleBarCodeChange}
        handlerGetData={this.handlerGetData}
        handlerCloseError={this.handlerCloseError}
        handlerCloseSuccess={this.handlerCloseSuccess}
        acceptTermsEvent={this.acceptTermsEvent}
        closeterms={this.closeterms}
        showTermsEvent={this.showTermsEvent}
        handleBarCodeBlur={this.handleBarCodeBlur}
        currencyConfiguration={this.props.currencyConfiguration}
        handleCoversionPointsValue={this.handleCoversionPointsValue}
        handleBillValue={this.handleBillValue}
      />
    )
  }
}

const mapStateToProps = ({
  participant: { cpf },
  oidc: {
    user: { profile }
  },
  catalog
}) => ({
  cpf: cpf,
  catalogId: profile['custom:catalog_id'],
  currencyConfiguration: catalog.currencyConfiguration
})

const mapDispatchToProps = dispatch => ({
  redirectConfirmation: path => dispatch(push(path))
})

ByllPaymentContainer.propTypes = {
  cpf: PropTypes.object,
  redirectConfirmation: PropTypes.func,
  handleBillValue: PropTypes.func,
  location: PropTypes.object,
  currencyConfiguration: PropTypes.object
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ByllPaymentContainer)



// WEBPACK FOOTER //
// ./src/features/BillPayment/BillPaymentContainer.js